import * as React from 'react';
import MaptilerMap from '@narvar/nth-block-maptiler-map';
import { Geocode } from '../../../../server/api/schema';

interface PickupLocationMapProps {
  featureName?: string;
  geocode?: Geocode | null;
}

const mapStyles: React.CSSProperties = {
  flexDirection: 'column',
  height: '12.5rem',
  width: '100%',
};

const PickupLocationMap: React.FunctionComponent<PickupLocationMapProps> = ({
  featureName,
  geocode,
}) => {
  if (!geocode?.lat || !geocode?.lng) return null;

  return (
    <div style={{ paddingRight: '0.5rem' }}>
      <MaptilerMap
        featureName={featureName}
        coordinates={{
          lat: geocode.lat,
          lng: geocode.lng,
        }}
        s={mapStyles}
      />
    </div>
  );
};

export default PickupLocationMap;
